export default __webpack_public_path__ + "static/media/OctoDesktop.23eb1bbc.svg";